export const META_DEFAULT_BASE_URL = 'https://www.udemy.com';

// <<Stencil::Block(globalAppConstants)>>
// <</Stencil::Block>>
